import { Suspense } from "react";
import { Outlet } from "react-router";

import LoadingFallback from "legacy/components/loading-fallback";

interface LegacyRouteLoadingBoundaryProps {
  loadingState: "dashboard" | "login";
}

const LegacyRouteLoadingBoundary = ({ loadingState }: LegacyRouteLoadingBoundaryProps) => (
  <Suspense fallback={<LoadingFallback path={loadingState} />}>
    <Outlet />
  </Suspense>
);

export { LegacyRouteLoadingBoundary };
